import React, { FC, memo } from "react";
import {
  Box,
  Grid,
  GridItem,
  Text,
  Stack,
  List,
  ListItem,
  HStack,
  Spacer,
  Link,
} from "@chakra-ui/react";
import { HomeLogoNavLink } from "../style";
import Icon from "@modules/Icon";
import SocialNetwork from "./SocialNetwork";
import { Link as GatsbyLink } from "gatsby";
import ResponsiveContainer from "./ResponsiveContainer";
import useCalendlyModal from "../hooks/useCalendlyModal";

const Footer: FC = () => {
  const { isCalendlyModalOpen, openCalendlyModal, closeCalendlyModal } =
    useCalendlyModal();

  return (
    <Box mt={8}>
      <ResponsiveContainer px={4}>
        <Stack display={{ base: "none", md: "flex" }}>
          <HomeLogoNavLink to="/" aria-label="home">
            <Icon name="logo" />
          </HomeLogoNavLink>
        </Stack>
        <Grid
          templateRows="repeat(1, 1fr)"
          templateColumns="repeat(12, 1fr)"
          gap={4}
          my={16}
        >
          <GridItem colSpan={[12, 6, 5]}>
            <List spacing={3}>
              <ListItem>
                <HStack>
                  <Icon name="USFlag" />
                  <Text textStyle={"h5"}>United States Office</Text>
                </HStack>
              </ListItem>
              <ListItem>85 Fulton Street Boonton, NJ 07005</ListItem>
              <ListItem>
                <Link
                  _hover={{ textDecoration: "none" }}
                  href={"tel:+1 973-334-1980"}
                  target="_blank"
                >
                  +1 973-334-1980
                </Link>
              </ListItem>
              <ListItem>
                <Link
                  href={"tel:+1 973-334-0545"}
                  target="_blank"
                  _hover={{ textDecoration: "none" }}
                >
                  +1 973-334-0545
                </Link>
              </ListItem>
              <ListItem>
                <Link
                  href={"mailto:info@commdevices.com"}
                  target="_blank"
                  _hover={{ textDecoration: "none" }}
                >
                  info@commdevices.com
                </Link>
              </ListItem>
            </List>
          </GridItem>
          <GridItem colSpan={[12, 6, 3]}>
            <List spacing={3}>
              <ListItem>
                <Text textStyle={"h5"}>Products</Text>
              </ListItem>
              <ListItem>
                <GatsbyLink to="/categories/pa100-government-series-commdevices-com/">
                  PA100 Series For Government
                </GatsbyLink>
              </ListItem>
              <ListItem>
                <GatsbyLink to="/categories/pa200-series-for-commercial/">
                  PA200 Series For Commercial
                </GatsbyLink>
              </ListItem>
              <ListItem>
                <GatsbyLink to="/categories/power-control-systems/">
                  Power Control Systems
                </GatsbyLink>
              </ListItem>
              <ListItem>
                <GatsbyLink to="/categories/management-console/">
                  Management Console
                </GatsbyLink>
              </ListItem>
            </List>
          </GridItem>
          <GridItem colSpan={[12, 6, 2]}>
            <List spacing={3}>
              <ListItem>
                <Text textStyle={"h5"}>Company</Text>
              </ListItem>
              <ListItem>
                <GatsbyLink to="/about-cdi/">About CDI</GatsbyLink>
              </ListItem>
              <ListItem>
                <GatsbyLink to="/our-team/">Our Team</GatsbyLink>
              </ListItem>
              <ListItem>
                <GatsbyLink to="/fisma/">About FIPS-FISMA</GatsbyLink>
              </ListItem>
              <ListItem>
                <Text textStyle={"h5"}>Support</Text>
              </ListItem>
              <ListItem>
                <GatsbyLink to="/contact-us/">Contact Us</GatsbyLink>
              </ListItem>
              <ListItem>
                <Link
                  href="https://support.commdevices.com/portal/en/signin"
                  _hover={{ textDecoration: "none" }}
                >
                  Support Center
                </Link>
              </ListItem>
            </List>
          </GridItem>
          <GridItem colSpan={[12, 6, 2]}>
            <List spacing={3}>
              <ListItem>
                <Text textStyle={"h5"}>Solutions</Text>
              </ListItem>
              <ListItem>
                <GatsbyLink to="/solutions/">Our Solutions</GatsbyLink>
              </ListItem>
              <ListItem>
                <GatsbyLink to="/use-cases/">Use Cases</GatsbyLink>
              </ListItem>
              <ListItem>
                <GatsbyLink to="/schedule-a-demo/">Schedule a Demo</GatsbyLink>
              </ListItem>
              <ListItem>
                <GatsbyLink to="/request-a-quote/">Request a Quote</GatsbyLink>
              </ListItem>
            </List>
          </GridItem>
        </Grid>

        <Box>
          <SocialNetwork />
        </Box>
      </ResponsiveContainer>

      <Box bg={"white20"}>
        <ResponsiveContainer px={4}>
          <HStack py={7} flexWrap="wrap">
            <Stack
              direction={{ base: "column", lg: "row" }}
              spacing={{ base: 4, lg: 10 }}
              minWidth={{ base: "100%", lg: "auto" }}
              mb={{ base: 4, lg: 0 }}
            >
              <GatsbyLink to={`/privacy-policy`}>
                <Text textStyle={"h6"}>Privacy Policy</Text>
              </GatsbyLink>
              <GatsbyLink to={`/term-and-condition`}>
                <Text textStyle={"h6"}>Terms & Conditions</Text>
              </GatsbyLink>
            </Stack>
            <Spacer />
            <Text
              textStyle={"h6"}
              minWidth={{ base: "100%", lg: "auto" }}
              marginLeft={"0 !important"}
            >
              © 2023 Communication Devices, Inc.
            </Text>
          </HStack>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default memo(Footer);
